<template>
  <div class="card">
    <div class="card-title">
      <span style="height:0.5rem; padding:0.1rem;background:#37A5DA;margin-right:0.2rem">&nbsp;</span>
      订阅人员
    </div>
    <div class="bind-list">
      <div class="bind-list-item bind-mb">
        <div class="bind-t-1" style="color: #454f63;">
          订阅人
        </div>
        <div class="bind-t-2" style="color: #454f63;">
          绑定手机号
        </div>
        <div class="bind-t-3">
          <!-- <div class="add">添加</div> -->
        </div>
      </div>
      <div
        class="bind-list-item"
        v-for="(item, index) in addPersonData"
        :key="index"
      >
        <div class="bind-t-1" style="color: #454f63;">
          {{ item.bandingUserName }}
        </div>
        <div class="bind-t-2" style="color: #454f63;">
          {{ item.bandingUserPhone }}
        </div>
        <div class="bind-t-3"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    num: {},
  },
  data() {
    return {
      addPersonData: [],
    }
  },
  mounted(){
    this.getSubPersonList(this.num)
  },
  methods:{
    async getSubPersonList(num) {
      try {
        const { code, data } = await this.$https.getSubPersonList({
          //schoolId: this.$store.state.pschoolId,
          orderNum: num,
        })
        if (code !== 200) {
          return false
        }
        this.addPersonData = data
      } catch (error) {}
    },
  }
}
</script>

<style lang="scss" scoped>
.card {
  .card-title {
    color: #454f63;
    font-size: 0.88rem;
    padding: 1.06rem;
    /* padding-top: 0; */
  }
  .bind-list {
    padding: 0.3rem 2.56rem;
    padding-right: 1.5rem;

    color: #454f63;
    .bind-list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1rem;
      &.bind-mb {
        margin-bottom: 1.19rem;
      }
      .bind-t-1 {
        width: 8rem;
        text-align: left;
        color: #454f63;
        font-size: 0.85rem;
        ::deep .van-cell {
          padding: 0;
        }
      }
      .bind-t-2 {
        width: 8rem;
        text-align: left;
        font-size: 0.85rem;
        color: #454f63;
        ::deep .van-cell {
          padding: 0;
        }
      }
      .bind-t-3 {
        /* width: 5rem; */
        text-align: center;
        width: 3.31rem;
        img {
          width: 1.05rem;
          height: 1.05rem;
        }
        .add {
          border: 0.06rem solid #e2bd78;
          border-radius: 0.75rem;
          width: 3.31rem;
          height: 1.25rem;
          text-align: center;
          line-height: 1.25rem;
          font-size: 0.88rem;
          color: #c28f22;
        }
      }
    }
  }
}
</style>
